import React from 'react';
import './TourBackdrop.css';

function TourBackdrop({ className }) {
  return (
    <div className={`tour-backdrop ${className || ''}`}></div>
  );
}

export default TourBackdrop;
